module.exports = __webpack_public_path__ + "img/delivery_engineer.c561747d.png";